<template>
	<ul class="copy-form-list" ref="copyFormResults">
		<CopyFormCard
			:form="form"
			:actionType="actionType"
			v-for="form in source.items"
			:key="form.id"
			:id="`form.id_form`"
		/>
		<Spinner
			:processor="{ loading: loadingSource }"
			:variant="spinnerVariant"
		/>
		<div class="end-results" v-if="hasNoMoreRecords">
			End of results
		</div>
		<NoResults v-show="hasNoResults" />
	</ul>
</template>

<script>
import CopyFormCard from './copy-form-card';
import Spinner from '@/components/visual/spinner/spinner';
import NoResults from '@/site-components/no-results/no-results';
import PagingMixins from '@/mixins/paging';
import ScrollMixins from '@/mixins/scroll-mixin';

export default {
	name: 'CopyFormsList',
	mixins: [PagingMixins, ScrollMixins],
	props: {
		source: {
			type: Object,
			default: () => {}
		},
		actionType: {
			type: String,
			default: 'Copy'
		}
	},
	components: {
		CopyFormCard,
		NoResults,
		Spinner
	},
	data() {
		return {
			pagingModelName: 'source',
			spinnerVariant: '',
			scrollElementName: 'copyFormResults'
		};
	},
	computed: {
		loadingSource() {
			return this.$store.getters['loader/loading']('get.forms');
		},
		hasNoResults() {
			if (this.loadingSource) {
				return false;
			}

			return !this.hasResults;
		}
	},
	watch: {
		hasPagination: {
			immediate: true,
			handler(val) {
				this.$emit('has-scroll', val);
			}
		},
		scrollEnd: {
			handler(val) {
				if (val) {
					this.$nextTick(() => {
						this.spinnerVariant = 'infinity-scroll';
						if (!this.loadingSource) {
							this.$emit('page', this.nextPage);
						}
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.copy-form-list {
	overflow: auto;
	margin-top: $gutter-lg;
	max-height: calc(100vh - 260px);
	@include scrollbar;

	@include mq($from: md) {
		max-height: calc(87vh - 320px);
	}
}
</style>
